import React, { useEffect, useState } from "react";
import {
    Drawer,
    Box,
    Typography,
    IconButton,
    Divider,
    Chip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from "@mui/material";
import Grid from "@mui/material/Grid";
import close from "../../assets/icons/close.png";
import expend from "../../assets/icons/expend.png";
import {
    getCURFQAssignedToMe,
    getCustomerRfqData,
    getKamProfilePicApi
} from "../Services/OrgRepo";
import { ThreeDot } from "react-loading-indicators";
import {
    generatProfilePicUrl,
    getLoggedInEmail,
    getLoggedInUserDepartment,
    getLoggedInUserID
} from "../../Utils/Constant";

export const CertificationDrawerInReview = ({
    open,
    onClose,
    selectedPartner
}) => {
    const [loading, setLoading] = useState(false);
    const [companyData, setCompanyData] = useState([]);
    const [profileImage, setProfileImage] = useState("");
    const getCompanyData = async () => {
        setLoading(true);
        try {
            let paylod = {};

            paylod = {
                userEmail: getLoggedInEmail()
            };

            const data = await getCustomerRfqData(paylod);
            if (data?.status) {
                setCompanyData(data?.data);
            } else {
                setCompanyData([]);
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
            setCompanyData([]);
            console.log("Error while fetching getCompanyData");
        }
    };

    const getProfilePic = async () => {
        try {
            const data = await getKamProfilePicApi(
                selectedPartner?.keyAccountManagerID ||
                    selectedPartner?.key_account_manger_Id
            );
            if (data?.status) {
                const img = generatProfilePicUrl(
                    selectedPartner?.keyAccountManagerID ||
                        selectedPartner?.key_account_manger_Id,
                    data?.data,
                    "Profile_Picture"
                );
                setProfileImage(img);
            } else {
                setProfileImage("");
            }
            setLoading(false);
        } catch (err) {
            setProfileImage("");
            console.log("Error while fetching getCompanyData");
        }
    };

    useEffect(() => {
        if (selectedPartner?.rfqName || selectedPartner?.curfq_name) {
            getCompanyData();
            setProfileImage("");
        }
        if (
            selectedPartner?.keyAccountManagerID ||
            selectedPartner?.key_account_manger_Id
        ) {
            getProfilePic();
        }
    }, [selectedPartner]);
    return (
        <Drawer anchor="right" open={open} onClose={onClose}>
            <Box sx={{ p: 2, width: { xs: "100%", sm: 400 } }}>
                {/* Header Section */}
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Typography variant="h6" fontWeight="bold">
                        Mandatory Certifications
                    </Typography>
                    <Box>
                        <IconButton onClick={onClose} sx={{ padding: "10px" }}>
                            <img src={close} width={"14px"} alt="Close" />
                        </IconButton>
                    </Box>
                </Box>

                <Divider sx={{ my: 2 }} />

                {/* Organisation Details */}
                <Box display="flex" alignItems="center" gap={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={5}>
                            <Typography variant="body2" color="text.secondary">
                                Company RFQ ID
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <Typography variant="body2">
                                {selectedPartner?.rfqID ||
                                    selectedPartner?.curfq_no ||
                                    "-"}
                            </Typography>
                        </Grid>

                        <Grid item xs={12} md={5}>
                            <Typography variant="body2" color="text.secondary">
                                Created By
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <Typography
                                variant="body2"
                                sx={{ display: "flex", alignItems: "center" }}
                            >
                                {profileImage && (
                                    <img
                                        src={profileImage}
                                        width={24}
                                        height={24}
                                        style={{
                                            marginRight: "5px",
                                            borderRadius: "50%"
                                        }}
                                        alt="KAM"
                                    />
                                )}

                                {selectedPartner?.keyAccountManager ||
                                    selectedPartner?.key_account_manger_name ||
                                    "-"}
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>

                <Divider sx={{ my: 2 }} />

                {/* Company Listing */}
                {!loading ? (
                    companyData?.length > 0 ? (
                        <>
                            <Typography
                                variant="subtitle1"
                                fontWeight="bold"
                                sx={{ mb: 1 }}
                            >
                                Certification Listing
                            </Typography>

                            <TableContainer
                                component={Paper}
                                sx={{
                                    maxHeight: 400,
                                    boxShadow: "none!important",
                                    border: "1px solid #F2F2F2"
                                }}
                            >
                                <Table
                                    aria-label="Companies Table"
                                    stickyHeader
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                sx={{
                                                    backgroundColor: "#E3E8EF"
                                                }}
                                            >
                                                Mandatory Certification
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    {selectedPartner?.rfqID ? (
                                        <TableBody>
                                            {(typeof selectedPartner?.mandatoryCertifications ===
                                            "string"
                                                ? selectedPartner.mandatoryCertifications.split(
                                                      ","
                                                  )
                                                : Array.isArray(
                                                        selectedPartner?.mandatoryCertifications
                                                    )
                                                  ? selectedPartner.mandatoryCertifications
                                                  : []
                                            ).map((cert, certIndex) => (
                                                <TableRow key={certIndex}>
                                                    <TableCell
                                                        sx={{ padding: "10px" }}
                                                    >
                                                        {cert.trim()}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    ) : (
                                        <TableBody>
                                            {(typeof selectedPartner?.certifications ===
                                            "string"
                                                ? selectedPartner.certifications.split(
                                                      ","
                                                  )
                                                : Array.isArray(
                                                        selectedPartner?.certifications
                                                    )
                                                  ? selectedPartner.certifications
                                                  : []
                                            ).map((cert, certIndex) => (
                                                <TableRow key={certIndex}>
                                                    <TableCell
                                                        sx={{ padding: "10px" }}
                                                    >
                                                        {cert.trim()}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    )}
                                </Table>
                            </TableContainer>
                        </>
                    ) : (
                        <Typography textAlign="center" color="text.secondary">
                            No Data Found
                        </Typography>
                    )
                ) : (
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        height="50vh"
                    >
                        <ThreeDot
                            color="#1976d2"
                            size="medium"
                            text=""
                            textColor=""
                        />
                    </Box>
                )}
            </Box>
        </Drawer>
    );
};
